// extracted by mini-css-extract-plugin
export var avatarContainer = "_dv-0";
export var avatarTypingWave = "_dv-i";
export var gray = "_dv-f";
export var green = "_dv-c";
export var icon = "_dv-9";
export var image = "_dv-1";
export var lg = "_dv-6";
export var md = "_dv-5";
export var presenceDot = "_dv-b";
export var red = "_dv-d";
export var sm = "_dv-4";
export var status = "_dv-a";
export var typingDot = "_dv-h";
export var typingPill = "_dv-g";
export var xl = "_dv-7";
export var xs = "_dv-3";
export var xxl = "_dv-8";
export var xxs = "_dv-2";
export var yellow = "_dv-e";